import React, {Dispatch, SetStateAction, useEffect, useMemo} from "react";
import {OcSearchParamType} from "../interface";
import {SubmitHandler, useForm, useWatch} from "react-hook-form";
import moment from "moment";
import {useModal} from "../../../../../hooks";
import {useUpdateExchangeRate} from "../hooks/useUpdateExchangeRate";
import {useReadExchangeRateForPeriod} from "../hooks/useReadExchangeRateForPeriod";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

interface PropsType {
    searchParam: OcSearchParamType
    setSearchParam: Dispatch<SetStateAction<OcSearchParamType>>
    selectedItem: number[]
    setSelectedItem: Dispatch<SetStateAction<number[]>>
}

export default function Filter({searchParam, setSearchParam, selectedItem, setSelectedItem}: PropsType) {
    const {handleModal} = useModal();

    const {register, handleSubmit, getValues, control, setValue, watch} = useForm({
        defaultValues: (() => ({
            ...searchParam,
            year: searchParam.year || moment().year().toString(),
            month: searchParam.month || (moment().month() + 1).toString()
        }))(),
    });

    const watchSearchParam = {
        ...searchParam,
        ...useWatch<OcSearchParamType>({control}),
    };

    // const {mutate: mutateExportOverseasStandardFormExcel} = useExportOverseasStandardFormExcel()
    const {mutate: mutateUpdateExchangeRate} = useUpdateExchangeRate({closeCallback: () => setSelectedItem([])})
    const {mutateAsync: mutateAsyncReadExchangeRateForPeriod} = useReadExchangeRateForPeriod()

    const btnApply = () => {
        if (selectedItem.length === 0) {
            handleModal({
                isOpen: true,
                contents: "선택된 항목이 없습니다.",
                type: "alert",
            });
        } else {
            mutateAsyncReadExchangeRateForPeriod({
                startAt: getValues("startAt"),
                endAt: getValues("endAt")
            }).then(res => {
                const data = res.data

                console.log("searchParam.region : ", searchParam.region);
                if (data.code === "0000") {
                    setValue("exchangeRate", data.result?.baseExchangeRate ?? 0)
                    mutateUpdateExchangeRate({
                        ...watchSearchParam,
                        overseasReqList: selectedItem.map(el => ({overseasId: el})),
                        region: searchParam.region
                    })
                }
            })
        }
    }

    // const btnDownloadExcelTemplate = () => {
    //     mutateExportOverseasStandardFormExcel()
    // }

    const onSubmit: SubmitHandler<OcSearchParamType> = (submitData) => {
        if (submitData.year === "" && submitData.month !== "") {
            handleModal({
                isOpen: true,
                contents: "연도를 선택해주세요.",
                type: "alert",
            });
        } else {
            setSearchParam({...submitData, pageNo: 1})
        }
    };

    const yearOptions = useMemo(() => {
        const currentYear = moment().year();

        const list = [<option value={""}>전체</option>]
        for (let i = currentYear; i >= 2023; i--) {
            list.push(<option value={i}>{i}</option>)
        }

        return list
    }, [])

    const monthOptions = useMemo(() => {
        const list = [<option value={""}>전체</option>]
        for (let i = 1; i <= 12; i++) {
            list.push(<option value={i}>{i}</option>)
        }

        return list
    }, [])

    useEffect(() => {
        if (getValues("year") || getValues("month")) {
            setValue("keywordType", "1")
        } else {
            setValue("keywordType", "0")
        }
    }, [watch("year"), watch("month")]);

    useEffect(() => {
        if (watch("exchangeFlag") == 1) {
            setValue("startAt", moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD"))
            setValue("endAt", moment().subtract(1, "months").endOf("month").format("YYYY-MM-DD"))
        }
    }, [watch("exchangeFlag")]);

    useEffect(() => {
        // 최초의 테이블 생성 시 현재 년도와 현재 월 기준으로 API 호출
        setSearchParam({
            ...searchParam,
            year: moment().year().toString(),
            month: (moment().month() + 1).toString(),
            pageNo: 1
        });
    }, []);

    return <div className="fiter_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">해외법인 검색</h3>
            <div className="filter_toolbar">
                {/*<button className="btn btn-outline-primary">*/}
                {/*    <img src={process.env.PUBLIC_URL + "/assets/images/icon_gear_blue.png"} alt=""/>컬럼설정*/}
                {/*</button>*/}
                {/*<button className="btn btn-primary">*/}
                {/*    저장*/}
                {/*</button>*/}
                {/*<button className="btn btn-info color2 w-170px" onClick={btnDownloadExcelTemplate}>*/}
                {/*    <img src={process.env.PUBLIC_URL + "/assets/images/icon_download.png"} alt=""/>엑셀 양식 다운로드*/}
                {/*</button>*/}
            </div>
        </div>
        <div className="row">
            <form className="col-6" onSubmit={handleSubmit(onSubmit)}>
                <div className="frm_row search justify-content-start">
                    <label htmlFor="" className="form-label frm_label">날짜</label>
                    <select className="form-select"
                            value={watch("year") || ""}
                            {...register("year")}>
                        {yearOptions}
                    </select>
                    <select className="form-select me-0"
                            value={watch("month") || ""}
                            {...register("month")}>
                        {monthOptions}
                    </select>
                    <button className="btn btn-info btn_search">
                        <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회
                    </button>
                </div>
            </form>

            <AuthorityChecker authorityNames={['overseasWriteYn']}>
                <div className="col-6">
                    <div className="frm_row">
                        <label htmlFor="" className="form-label frm_label">환율 일괄 적용</label>
                        <div className="frm_field">
                            <div className="form-check form-check-inline">
                                <input className="form-check-input"
                                       type="radio"
                                       id="inlineRadio1"
                                       checked={watch("exchangeFlag") == 1}
                                       value="1"
                                       {...register("exchangeFlag")}/>
                                <label className="form-check-label" htmlFor="inlineRadio1">전월 평균</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input className="form-check-input"
                                       type="radio"
                                       id="inlineRadio2"
                                       value="2"
                                       checked={watch("exchangeFlag") == 2}
                                       {...register("exchangeFlag")}/>
                                <label className="form-check-label" htmlFor="inlineRadio2">기간 평균</label>
                            </div>
                            <span className="text-danger">* 매매기준율 최초고시 기준</span>
                        </div>
                    </div>
                    <div className="frm_row">
                        <label htmlFor="" className="form-label frm_label"></label>
                        <div className="frm_field input_date">
                            <input type="date"
                                   className="form-control"
                                   value={watch("startAt")}
                                   {...register("startAt")}
                                   disabled={watch("exchangeFlag") == 1}/>
                            <span className="txt_range">~</span>
                            <input type="date"
                                   className="form-control"
                                   value={watch("endAt")}
                                   {...register("endAt")}
                                   disabled={watch("exchangeFlag") == 1}/>
                            <span className="form-control" style={{border: "none", textAlign: "right"}}>
                            {watch("exchangeRate")}
                        </span>
                            <button className="btn btn-info btn_search w-80px" onClick={btnApply}>적용</button>
                        </div>
                    </div>
                </div>
            </AuthorityChecker>
        </div>
    </div>
}